<ll-titulo>Generar Nuevo Instrumento</ll-titulo>

<generar-instrumento-admin [tipoEvaluacion]="tipoInstrumento" [enableBuscador]="true"></generar-instrumento-admin>
